<app-grid-table
  [columns]="columns"
  [rowData]="renderEvents() || []"
  [showHeaderOption]="false"
/>
